import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { TabMenu, PageHeader } from '..';

const Index = (props) => {
  const { menu, title, description, additionalComponent } = props;
  const location = useLocation();

  const { pathname } = location;
  const [selectedMenu, setSelectedMenu] = useState(pathname);

  const isMainRoute = menu.filter((menuItem) => {
    return menuItem.value === location.pathname;
  });

  useEffect(() => {
    setSelectedMenu(pathname);
  }, [pathname]);

  if (isMainRoute.length > 0) {
    return (
      <>
        <PageHeader title={title} description={description} />
        <TabMenu
          menus={menu}
          selectedMenu={selectedMenu}
          setSelectedMenu={setSelectedMenu}
          withURL
          additionalComponent={additionalComponent}
        />
      </>
    );
  }
  return <></>;
};

export default Index;
